export const navbar = {
    // 用户下拉菜单
    "navbar_update_password": "Update Password",
    "navbar_logout": "Logout",
    // 其他
    "navbar_menu": "Menu",
    // 登录按钮（未登录状态）
    "navbar_login": "Login",
    // 其他导航
    "navbar_to_Management": "Management",
    "navbar_to_FileLog": "File Log",
    // 修改密码弹窗
    "navbar_update_password_modal_title": "Update Password",
    "navbar_change_password_button": "Change Password",
    // 密码验证与反馈消息
    "navbar_password_mismatch": "New password and confirm password do not match.",
    "navbar_password_update_success_message": "Password updated successfully.",
    "navbar_password_update_success_notify": "Update password successfully.",
    "navbar_password_update_failed": "Failed to update password.",
    // 表单标签与提示
    "navbar_original_password": "Original Password",
    "navbar_new_password": "New Password",
    "navbar_confirm_new_password": "Confirm New Password",
};
